import { GET_DETAILSUBVENDOR_FAILED, GET_DETAILSUBVENDOR_REQUESTED, GET_DETAILSUBVENDOR_SUCCESS, GET_SUBADDVENDOR_FAILED, GET_SUBADDVENDOR_REQUESTED, GET_SUBADDVENDOR_SUCCESS, GET_SUBVENDOR_FAILED, GET_SUBVENDOR_REQUESTED, GET_SUBVENDOR_SUCCESS, UPDATE_SUBADDVENDOR_FAILED, UPDATE_SUBADDVENDOR_REQUESTED, UPDATE_SUBADDVENDOR_SUCCESS } from "resources/actionTypes";


const initialState = {
  userSubVendor: [],
  loading: false,
  error: null,
};
const initialStateAdd = {
  userAddSubVendor: [],
  loading: false,
  error: null,
};
const initialStateUpdate = {
  userUpdateSubVendor: [],
  loading: false,
  error: null
}
const initialStateDetail = {
  userDetailSubVendor: [],
  loading: false,
  error: null
}


export function userSubVendor(state = initialState, action) {
  switch (action.type) {
    case GET_SUBVENDOR_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_SUBVENDOR_SUCCESS:
      return {
        ...state,
        loading: false,
        userSubVendor: action.userSubVendor,
      };
    case GET_SUBVENDOR_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userAddSubVendor(state = initialStateAdd, action) {
  switch (action.type) {
    case GET_SUBADDVENDOR_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_SUBADDVENDOR_SUCCESS:
      return {
        ...state,
        loading: false,
        userAddSubVendor: action.userAddSubVendor,
      };
    case GET_SUBADDVENDOR_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userUpdateSubVendor(state = initialStateUpdate, action) {
  switch (action.type) {
    case UPDATE_SUBADDVENDOR_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_SUBADDVENDOR_SUCCESS:
      return {
        ...state,
        loading: false,
        userUpdateSubVendor: action.userUpdateSubVendor,
      };
    case UPDATE_SUBADDVENDOR_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}

export function userDetailSubVendor(state = initialStateDetail, action) {
  switch (action.type) {
    case GET_DETAILSUBVENDOR_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_DETAILSUBVENDOR_SUCCESS:
      return {
        ...state,
        loading: false,
        userDetailSubVendor: action.userDetailSubVendor,
      };
    case GET_DETAILSUBVENDOR_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}
